import TextStyle from "common/enums/ElementNodeType";
import PromptInputType from "common/enums/PromptInputType";
import TreeType from "common/enums/form/AccessibilityTreeType";

class RowSymbol {
    constructor(controls) {
        this.controls = controls;
    }

    getControls() {
        return this.controls.map(function(c) {
            return {
                type: TreeType.CONTROL,
                control: c,
                labelledBy: []
            }
        });
    }

    parse(list) {
        return this.getControls();
    }
}



class BUTTON extends RowSymbol {}

function canBeLabelledByOtherControl(control) {
    return control.inputType === PromptInputType.SWITCH && !control.label
}

function canLabelOtherControl(control) {
    return control.inputType === PromptInputType.READ_ONLY &&
        (control.textStyle === TextStyle.PARAGRAPH || !control.textStyle);
}
class MIXED extends RowSymbol {
    parse(list) {
        const controls = this.getControls();
        let i = 0;
        while(i < controls.length) {
            const c = controls[i];
            i++;
            if(canBeLabelledByOtherControl(c.control)) {
                while(i < controls.length && canLabelOtherControl(controls[i].control)) {
                    c.labelledBy.push(controls[i].control);
                    i++;
                }
            }
        }
        return controls;
    }
}

class HeaderRowSymbol extends RowSymbol {

    getLabel() {
        return this.controls.slice(0, 1);
    }

    getDescription() {
        return this.controls.slice(1);
    }

    isBelow(symbol) {
        return symbol instanceof MIXED;
    }

    parse(list) {
        const describedBy = this.getDescription();
        const labelledBy = this.getLabel();
        const text = this.getControls();

        //Paragraphs can exist, but don't have to. If they do, they are a description
        while(list.peek() instanceof PARAGRAPH) {
            const para = list.next();
            describedBy.push.apply(describedBy, para.getLabel());
            describedBy.push.apply(describedBy, para.getDescription());
            text.push.apply(text, para.getControls());
        }

        const children = [];
        while(this.isBelow(list.peek())) {
            children.push.apply(children, list.next().parse(list));
        }

        if(children.length > 0) {
            return [{
                type: TreeType.GROUP,
                children: text.concat(children),
                labelledBy: labelledBy,
                describedBy: describedBy
            }];
        } else {
            return text;
        }
    }
}

class H1 extends HeaderRowSymbol {
    isBelow(symbol) {
        return symbol instanceof MIXED || symbol instanceof PARAGRAPH ||
            symbol instanceof H4 || symbol instanceof H3 || symbol instanceof H2;
    }
}
class H2 extends HeaderRowSymbol {
    isBelow(symbol) {
        return symbol instanceof MIXED || symbol instanceof PARAGRAPH ||
            symbol instanceof H4 || symbol instanceof H3;
    }
}
class H3 extends HeaderRowSymbol {
    isBelow(symbol) {
        return symbol instanceof MIXED || symbol instanceof PARAGRAPH ||
            symbol instanceof H4;
    }
}
class H4 extends HeaderRowSymbol {
    isBelow(symbol) {
        return symbol instanceof MIXED || symbol instanceof PARAGRAPH;
    }
}
class PARAGRAPH extends HeaderRowSymbol {}

function toRowSymbol(controls) {
    if(controls.every(control => control.inputType === PromptInputType.READ_ONLY)) {
        if(controls[0].textStyle === TextStyle.HEADING_1) {
            return new H1(controls);
        } else if(controls[0].textStyle === TextStyle.HEADING_2) {
            return new H2(controls);
        } else if(controls[0].textStyle === TextStyle.HEADING_3) {
            return new H3(controls);
        } else if(controls[0].textStyle === TextStyle.HEADING_4) {
            return new H4(controls);
        } else {
            return new PARAGRAPH(controls);
        }
    } else if(controls.every(c => c.inputType === PromptInputType.BUTTON) && controls.some(c => !!c.defaultButton)) {
        return new BUTTON(controls);
    } else {
        return new MIXED(controls);
    }
}

function convertToRows(controls) {
    let rows = [];
    for(let i = 0; i < controls.length; i++) {
        if(rows.length === 0 || rows[rows.length - 1][0].row !== controls[i].row) {
            rows.push([controls[i]]);
        } else {
            rows[rows.length - 1].push(controls[i]);
        }
    }
    return rows;
}

class SymbolList {
    constructor(rows) {
        this.symbols = rows.map(toRowSymbol);
        this.i = 0;
    }

    peek() {
        if(this.i < this.symbols.length) {
            return this.symbols[this.i];
        } else {
            return null;
        }
    }

    next() {
        const res = this.peek();
        this.i++;
        return res;
    }
}

export default function parseAccessibilityTree(controls) {
    const list = new SymbolList(convertToRows(controls));

    const res = [];
    while(list.peek() instanceof RowSymbol) {
        res.push.apply(res, list.next().parse(list));
    }
    return res;
}
